import { useCallback, useRef } from "react";

/**
 * Custom hook to lazy load the exportComponentAsJPEG function from react-component-export-image
 * This helps reduce the initial bundle size by loading the library only when needed
 */
export const useExportComponentAsImage = () => {
  const exportFunctionRef = useRef<any>(null);

  const exportAsJPEG = useCallback(
    async (componentRef: React.RefObject<HTMLDivElement>, fileName: string) => {
      try {
        // Lazy load the export function only when needed
        if (!exportFunctionRef.current) {
          const module = await import("react-component-export-image");
          exportFunctionRef.current = module.exportComponentAsJPEG;
        }

        // Call the export function
        await exportFunctionRef.current(componentRef, { fileName });
      } catch (error) {
        console.error("Failed to export component as image:", error);
      }
    },
    [],
  );

  return { exportAsJPEG };
};
